import * as z from "zod";

//Registratiion Schema
export const registerSchema = z
  .object({
    first_name: z.string().min(2, { message: "First Name is required" }),
    last_name: z.string().min(2, { message: "Last Name is required" }),
    other_names: z.string().optional(),
    gender: z.string().optional(),
    role_id: z.string().uuid({ message: "Select a Role" }),
    community_id: z.string().optional(),
    organization_id: z.string().uuid({ message: "Select an Organization" }),
    email: z.string().email({ message: "Email is required" }),
    password: z
      .string()
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/, {
        message:
          "8 to 24 characters, \nMust include uppercase and lowercase letters, a number and a  special character.",
      }),
    confirm_password: z.string(),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: "Password does not match",
    path: ["confirm_password"],
  });

//Invite Registratiion Schema
export const inviteRegisterSchema = z
  .object({
    first_name: z.string().min(2, { message: "First Name is required" }),
    last_name: z.string().min(2, { message: "Last Name is required" }),
    other_names: z.string().optional(),
    email: z.string().email({ message: "Email is required" }),
    password: z
      .string()
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/, {
        message:
          "8 to 24 characters, Must include uppercase lowercase letters, a number a special character.",
      }),
    confirm_password: z.string(),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: "Password does not match",
    path: ["confirm_password"],
  });

//Login Schema
export const loginSchema = z.object({
  email: z.string().email({ message: "Email is required" }),
  password: z
    .string()
    .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/, {
      message:
        "8 to 24 characters, Must include uppercase and lowercase letters, a number and a  special character.",
    }),
});

//Forgot password schema
export const forgotPasswordSchema = z.object({
  email: z.string().email({ message: "Email is required" }),
});

//Resetting password schema
export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/, {
        message:
          "8 to 24 characters, \nMust include uppercase and lowercase letters, a number and a  special character.",
      }),
    confirm_password: z.string(),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: "Password does not match",
    path: ["confirm_password"],
  });

//Add Country
export const addCountrySchema = z.object({
  name: z.string().min(3),
});

//Add Community
export const addCommunitySchema = z.object({
  name: z
    .string()
    .min(3, { message: "Minimum of 3 characters" })
    .max(150, { message: "Not more than 150 characters" }),
  organization_id: z.string().uuid({ message: "Select Organization" }),
  email: z.string().email({ message: "Email is required" }),
  address1: z
    .string()
    .min(3, { message: "Address should be a minimum of 3 characters" })
    .max(100, { message: "Add Adress less than 100 characters" }),
  address2: z
    .string()
    .min(3, { message: "Address 2 should be a minimum of 3 characters" })
    .max(100, { message: "Address should be a maximum of 100 characters" })
    .optional(),
  city: z
    .string()
    .min(3, { message: "City must be more than 3 characters" })
    .max(30, { message: "City must be less than 30 Characters" }),
});
//Add Community
export const addNationSchema = z.object({
  name: z
    .string()
    .min(3, { message: "Minimum of 3 characters" })
    .max(150, { message: "Not more than 150 characters" }),
  country_id: z.coerce.number({ message: "Select Country" }),
  email: z.string().email({ message: "Email is required" }),
  type: z.string().min(3, { message: "Please select Type" }),
  address1: z
    .string()
    .min(3, { message: "Address should be a minimum of 3 characters" })
    .max(100, { message: "Add Adress less than 100 characters" }),
  address2: z
    .string()
    .min(3, { message: "Address 2 should be a minimum of 3 characters" })
    .max(100, { message: "Address should be a maximum of 100 characters" })
    .optional(),
  phone: z
    .string()
    .min(3, { message: "Phone must be more than 3 characters" })
    .max(10, { message: "Phone must be less than 10 Characters" }),
  phone2: z
    .string()
    .min(3, { message: "Phone must be more than 3 characters" })
    .max(10, { message: "Phone must be less than 10 Characters" }),
});

//Add Donor
export const addDonorSchema = z.object({
  name: z
    .string()
    .min(3, { message: "Minimum of 3 characters" })
    .max(150, { message: "Not more than 150 characters" }),
  country_id: z.coerce.number({ message: "Select Country" }),
  currency_id: z
    .string()
    .uuid({ message: "Select Currency" })
    .min(4, { message: "Select Currency" }),
  province_id: z.string().uuid({ message: "Select Province" }),
  address1: z
    .string()
    .min(3, { message: "Address should be a minimum of 3 characters" })
    .max(100, { message: "Add Adress less than 100 characters" }),
  address2: z
    .string()
    .min(3, { message: "Address 2 should be a minimum of 3 characters" })
    .max(100, { message: "Address should be a maximum of 100 characters" })
    .optional(),
  phone: z
    .string()
    .min(9, { message: "Minimum number should be 10" })
    .max(10, { message: "Maximum number should be 10" }),
  phone2: z
    .string()
    .min(9, { message: "Minimum number should be 10" })
    .max(10, { message: "Maximum number should be 10" })
    .optional(),
  email: z.string().email({ message: "Email is required" }),
});

//Edit Donor
export const editDonorSchema = z.object({
  name: z
    .string()
    .min(3, { message: "Minimum of 3 characters" })
    .max(150, { message: "Not more than 150 characters" }),
  country_id: z.coerce.number({ message: "Select Country" }),
  province_id: z.string().uuid({ message: "Select Province" }),
  address1: z
    .string()
    .min(3, { message: "Address should be a minimum of 3 characters" })
    .max(100, { message: "Add Adress less than 100 characters" }),
  address2: z
    .string()
    .min(3, { message: "Address 2 should be a minimum of 3 characters" })
    .max(100, { message: "Address should be a maximum of 100 characters" })
    .optional(),
  phone: z
    .string()
    .min(9, { message: "Minimum number should be 10" })
    .max(10, { message: "Maximum number should be 10" }),
  phone2: z
    .string()
    .min(9, { message: "Minimum number should be 10" })
    .max(10, { message: "Maximum number should be 10" })
    .optional(),
  email: z.string().email({ message: "Email is required" }),
});

//Add Department
export const addDepartmentSchema = z.object({
  province_id: z.string().uuid({ message: "Select Province" }),
  name: z
    .string()
    .min(2, { message: "Minimum of 3 characters" })
    .max(90, { message: "Not more than 90 characters" }),
  slug: z
    .string()
    .min(2, { message: "Minimum number should be 10" })
    .max(90, { message: "Maximum number should be 90" }),
});

//Add Region
export const addRegionSchema = z.object({
  name: z.string().min(3),
  country_id: z.string().refine((val) => !Number.isNaN(parseInt(val, 10)), {
    message: "Expected number, received a string",
  }),
});

//Add Beneficiary profile
export const addBeneficiaryProfileSchema = z.object({
  id: z.string().nullable().optional(),
  title: z
    .string()
    .min(5, { message: "Minimun char is 5" })
    .max(170, { message: "Not mor than 170 char" }),
  community_id: z.string().uuid(),
  created_by: z.string().uuid(),
  province_id: z
    .string()
    .uuid({ message: "You do not belong to any Province" }),
  project_location: z
    .string()
    .min(3, { message: "Must contain at least 3 characters" })
    .max(100, { message: "Maximum length is 100 characters" }),
  longitude: z.string().optional().nullable(),
  latitude: z.string().optional().nullable(),
  phone: z
    .string()
    .min(9, { message: "Number must be at least 10 digits" })
    .max(10, { message: "Number must be most 10 digits" }),
});

//Add Problem Statement with restriction
export const addProblemStatementShema = z.object({
  id: z.string().uuid(),
  analysis: z
    .string({ message: "Add Analysis" })
    .min(5, { message: "Minimum should be 5 characters" }),
  problem_statement: z
    .string({ message: "Add Problem Statement" })
    .min(5, { message: "Minimum should be 5 characters" }),
  proposed_solution: z
    .string({ message: "Add proposed Solution" })
    .min(5, { message: "Minimum should be 5 characters" }),
  supporting_docs: z
    .any()
    .refine((files) => files && files.length > 0, {
      message: "At least one file is required",
    })
    .refine((files) => files && files.length < 5, {
      message: "At most four file is required",
    })
    .refine(
      (files) =>
        Array.from(files).every((file) => file.size <= 5 * 1024 * 1024), // Limit each file to 2MB
      {
        message: "Each file should be less than 2MB",
      }
    ),
});
//Add Problem Statement without restriction
export const addProblemStatementShema2 = z.object({
  id: z.string().uuid(),
  analysis: z
    .string({ message: "Add Analysis" })
    .min(5, { message: "Minimum should be 5 characters" }),
  problem_statement: z
    .string({ message: "Add Problem Statement" })
    .min(5, { message: "Minimum should be 5 characters" }),
  proposed_solution: z
    .string({ message: "Add proposed Solution" })
    .min(5, { message: "Minimum should be 5 characters" }),
  supporting_docs: z
    .any()
    // .refine((files) => files && files.length > 0, {
    //   message: "At least one file is required",
    // })
    .refine((files) => files && files.length < 5, {
      message: "At most four file is required",
    })
    .refine(
      (files) =>
        Array.from(files).every((file) => file.size <= 5 * 1024 * 1024), // Limit each file to 2MB
      {
        message: "Each file should be less than 2MB",
      }
    ),
});

//
//
//
//
//
// Proposal
///
export const addProposalBasicsSchema = z.object({
  id: z.string().nullable().optional(),
  description: z
    .string()
    .min(3, { message: "Description must be more than 2 characters" }),
  planned_start_date: z.string().date(),
  planned_end_date: z.string().date(),
});

export const addProposalBackgroundSchema = z.object({
  id: z.string().nullable().optional(),
  aim: z
    .string({ message: "Aim must be added" })
    .min(3, { message: "Aim should be more than 3 characters" }),
  purpose: z
    .string({ message: "Purpose must be added" })
    .min(3, { message: "Purpose should be more than 3 characters" }),
  selected_indicators: z
    .string({ message: "Selected Indicators must be added" })
    .min(3, {
      message: "Selected Indicators should be more than 3 characters",
    }),
  expected_results: z
    .object({
      id: z.string().nullable().optional(),
      number: z.number(),
      name: z
        .string()
        .min(3, { message: "Item is should be more than three characters" })
        .max(200, {
          message: "Item is should not be more than 200 characters",
        }),
    })
    .array()
    .nonempty({ message: "Can't be empty" }),
  activities: z
    .object({
      id: z.string().nullable(),
      number: z.number(),
      name: z
        .string()
        .min(3, { message: "Item is should be more than three characters" })
        .max(200, {
          message: "Item is should not be more than 200 characters",
        }),
    })
    .array()
    .nonempty({ message: "Can't be empty" }),
  objectives: z
    .object({
      id: z.string().nullable(),
      number: z.number(),
      name: z
        .string()
        .min(3, { message: "Item is should be more than three characters" })
        .max(200, {
          message: "Item is should not be more than 200 characters",
        }),
    })
    .array()
    .nonempty({ message: "Can't be empty" }),
});

export const addProposalDetailsSchema = z.object({
  id: z.string().nullable().optional(),
  sustainability_plan: z.string().min(3, {
    message: "Sustainability plan should be more than 3 characters",
  }),
  justification: z.string().min(3, {
    message: "Justification should be more than 3 characters",
  }),
  monitoring_supervision: z.string().min(3, {
    message: "Monitoring should be more than 3 characters",
  }),
});

export const addProposalBudgetSchema = z.object({
  id: z.string().nullable().optional(),
  budget_id: z.string().nullable().optional(),
  currency_id: z.string().min(2, { message: "Please Select Currency" }),
  budgets: z
    .object({
      id: z.string().nullable().optional(),
      account_id: z.string().uuid({ message: "Select Account" }).nullable(),
      name: z
        .string()
        .min(2, { message: "Minimum of 2 characters" })
        .max(200, { message: "Max of 200 characters" }),
      sub_category_id: z.string().uuid({ message: "Required" }),
      quantity: z.coerce.number().refine((item) => item > 0),
      amount: z.coerce.number().refine((item) => item > 0),
    })
    .array()
    .nonempty({ message: "Must not be empty" }),
});

export const addProposalIssuesSchema = z.object({
  id: z.string().nullable().optional(),
  issues: z.string().min(3, {
    message: "Issues should be more than 3 characters",
  }),
  stakeholder_target_group: z
    .string()
    .min(3, { message: "Item is should be more than three characters" })
    .max(100, {
      message: "Item is should not be more than 100 characters",
    }),
  male_beneficiaries: z.coerce.number().refine((item) => item > 0),
  female_beneficiaries: z.coerce.number().refine((item) => item > 0),
});

/**
 *
 *
 *
 * Approvals
 */

export const addCommunityApproveSchema = z.object({
  id: z.string(),
  comment: z.string().min(2, { message: "Comment is required" }),
  community_council_minute: z
    .any()
    .refine((files) => files && files.length !== 0, {
      message: "Please Select a file",
    })
    .refine(
      (file) => file.size <= 5 * 1024 * 1024, // Limit each file to 2MB
      {
        message: "Each file should be less than 5MB",
      }
    ),
});

export const addCommunityProposalApproveSchema = z.object({
  id: z.string(),
  assigned_to: z.string().uuid().nullable(),
  comment: z.string().min(2, { message: "Comment is required" }),
  community_council_minute: z
    .any()
    .refine((files) => files && files.length !== 0, {
      message: "Please Select a file",
    })
    .refine(
      (file) => file.size <= 5 * 1024 * 1024, // Limit each file to 2MB
      {
        message: "Each file should be less than 5MB",
      }
    ),
});

export const addRequestRejectSchema = z.object({
  id: z.string(),
  comment: z.string().min(2, { message: "Comment is required" }),
});

export const addProvincialApproveSchema = z.object({
  id: z.string(),
  comment: z.string().min(2, { message: "Comment is required" }),
  provincial_council_minute: z
    .any()
    .refine((files) => files && files.length !== 0, {
      message: "Please Select a file",
    })
    .refine(
      (file) => file.size <= 5 * 1024 * 1024, // Limit each file to 2MB
      {
        message: "Each file should be less than 5MB",
      }
    ),
});

export const addPDORequestLetterSchema = z.object({
  id: z.string().uuid(),
  partner_id: z.string().uuid({ message: "Please Select Proposal Developer" }),
  body: z.string().min(3, { message: "Please add Email Body" }),
  subject: z.string().min(3, { message: "Please add Email Subject or Title" }),
});

export const addPDOLetterSchema = z.object({
  id: z.string().uuid(),
  partner_id: z.string().uuid({ message: "Please Select Proposal Developer" }),
  body: z.string().min(3, { message: "Please add Email Body" }),
  subject: z.string().min(3, { message: "Please add Email Subject or Title" }),
});

export const addPDOProposalLetterSchema = z.object({
  id: z.string().uuid(),
  comment: z.string().min(3, { message: "Please add Email Body" }),
  subject: z.string().min(3, { message: "Please add Email Subject or Title" }),
  reference_id: z.string().min(3, { message: "Add Reference Id" }),
});

/**
 *
 *
 * User
 */

//Add User
export const addUserSchema = z
  .object({
    first_name: z.string().min(2, { message: "First Name is required" }),
    last_name: z.string().min(2, { message: "Last Name is required" }),
    other_names: z.string().optional(),
    role_id: z.string().uuid({ message: "Select a Role" }),
    organization_id: z.string().uuid({ message: "Select an Organization" }),
    community_id: z.string().optional(),
    province_id: z.string().optional(),
    department_id: z.string().optional(),
    email: z.string().email({ message: "Email is required" }),
    password: z
      .string()
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/, {
        message:
          "8 to 24 characters, \nMust include uppercase and lowercase letters, a number and a  special character.",
      }),
    confirm_password: z.string(),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: "Password does not match",
    path: ["confirm_password"],
  });

//Edit User
export const editUserSchema = z.object({
  first_name: z.string().min(2, { message: "First Name is required" }),
  last_name: z.string().min(2, { message: "Last Name is required" }),
  other_names: z.string().optional(),
  role_id: z.string().uuid({ message: "Select a Role" }),
  organization_id: z.string().uuid({ message: "Select an Organization" }),
  community_id: z.string().optional(),
  department_id: z.string().nullable().optional(),
  province_id: z.string().optional(),
});

//Add User
export const inviteUserSchema = z.object({
  role_id: z.string().uuid({ message: "Select a Role" }),
  organization_id: z.string().uuid({ message: "Select an Organization" }),
  community_id: z.string().optional(),
  department_id: z.string().optional(),
  email: z.string().email({ message: "Email is required" }),
});

//Add User
export const addTaskRecordSchema = z.object({
  task_id: z.string().uuid({ message: "Select a Task" }),
  user_id: z.string().uuid({ message: "Select an User" }),
  name: z.string().email({ message: "Email is required" }),
  amount: z.coerce.number(),
  description: z.string().email({ message: "Email is required" }),
  files: z.object({}).array().optional(),
  images: z.object({}).array().optional(),
});

//Add  Account
export const addAccountSchema = z.object({
  name: z
    .string({ message: "Project Account name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" }),
  account_type_id: z
    .string({ message: "Select Account Type " })
    .uuid({ message: "Select Account Type " }),
  currency_id: z
    .string({ message: "Select Currency  " })
    .uuid({ message: "Select Currency  " }),
  category_id: z
    .string({ message: "Select Category  " })
    .uuid({ message: "Select Category  " }),
});

//Add  Account
export const editAccountSchema = z.object({
  id: z.string().uuid({ message: "Id is required" }),
  name: z
    .string({ message: "Project Account name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" }),
  account_type_id: z
    .string({ message: "Select Account Type " })
    .uuid({ message: "Select Account Type " }),
  // .min(5, { message: "Select Account Type  " }),
  currency_id: z
    .string({ message: "Select Currency  " })
    .uuid({ message: "Select Currency  " }),
  // .min(5, { message: "Select Currency  " }),
  category_id: z
    .string({ message: "Select Category  " })
    .uuid({ message: "Select Category  " }),
  // .min(5, { message: "Select Category  " }),
});

//Add Project Account
export const addProjectAccountSchema = z.object({
  name: z
    .string({ message: "Account name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" }),
  project_id: z.string().uuid({ message: "Select Account Type " }),
  account_type_id: z.string().uuid({ message: "Select Account Type " }),
  category_id: z.string().optional().nullable(),
});

//Add Account Category
export const addAccountCategorySchema = z.object({
  name: z
    .string({ message: "Account name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" }),
  account_type_id: z.string().uuid({ message: "Select Account Type " }),
  subCategories: z
    .object({
      id: z.string().uuid().nullable(),
      name: z.string().min(3, { message: "Minimum of # letters" }),
    })
    .array(),
});

//Add Account Category
export const editAccountCategorySchema = z.object({
  id: z.string().uuid({ message: "Id is required" }),
  name: z
    .string({ message: "Category name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" }),
  account_type_id: z.string().uuid({ message: "Select Account Type " }),
  subCategories: z
    .object({
      id: z.string().uuid().nullable(),
      name: z.string().min(3, { message: "Minimum of # letters" }),
    })
    .array(),
});

//Add Account Category
export const addRoleSchema = z.object({
  province_id: z.string().uuid({ message: "Id is required" }),
  name: z
    .string({ message: "Role name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" })
    .max(30, { message: "Role must not be more than 30 characters" }),
  description: z
    .string({ message: "Descrition name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" })
    .max(70, { message: "Role must not be more than 70 characters" }),

  color: z.string().min(3, { message: "Select Color" }),
});

//Add Account Category
export const editRoleSchema = z.object({
  id: z.string().uuid({ message: "Id is required" }),
  province_id: z.string().uuid({ message: "Id is required" }),
  name: z
    .string({ message: "Role name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" })
    .max(30, { message: "Role must not be more than 30 characters" }),
  description: z
    .string({ message: "Descrition name is Required" })
    .min(3, { message: "Minimum Name should be 3 character" })
    .max(70, { message: "Role must not be more than 70 characters" }),

  color: z.string().min(3, { message: "Select Color" }),
});

//Add Receipt Transaction
export const addReceiptTransactionSchema = z.object({
  currency_id: z.string().uuid({ message: "Currency requred" }),
  method_id: z.string().uuid({ message: "Payment method requred" }),
  sender_id: z.string().uuid({ message: "Account requred" }),
  receiver_id: z.string().uuid({ message: "Account requred" }),
  project_id: z.string().uuid({ message: "Project requred" }),
  naration: z
    .string()
    .min(3, { message: "Naration required above 3 characters" }),
  amount: z.coerce.number().refine((i) => i > 0),
  exchange_rate: z.coerce.number().refine((i) => i > 0),
  date: z.date({ coerce: true }),
});

//Add Receipt Transaction
export const addPaymenttTransactionSchema = z.object({
  currency_id: z.string().uuid({ message: "Currency requred" }),
  method_id: z.string().uuid({ message: "Payment method requred" }),
  sender_id: z.string().uuid({ message: "Account requred" }),
  receiver_id: z.string().uuid({ message: "Account requred" }),
  naration: z
    .string()
    .min(3, { message: "Naration required above 3 characters" }),
  amount: z.coerce.number().refine((i) => i > 0),
  exchange_rate: z.coerce.number().refine((i) => i > 0),
  date: z.date({ coerce: true }),
});

//Add Payment Transaction
export const addPaymentTransaction = z.object({});
